// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hg","advertCardNum":"c-a_hh"};